// libs
import React, { memo } from 'react';

// styles
import { Container, Loader } from './styles';

// defs
interface IVideoPlayerProps {
  width: number;
  poster: string;
}

function Placeholder({ width, poster }: IVideoPlayerProps) {
  const onClick: React.MouseEventHandler = (e) => {
    e.stopPropagation();
  };

  return (
    <Container width={width} onClick={onClick} backgroundImage={poster}>
      <Loader />
    </Container>
  );
}

export default memo(Placeholder);
